const items = [
  "California LCSW",
  "Nearly 20 Years Clinical Experience",
  "Trauma-Informed Care",
  "Secure Telehealth Statewide",
  "Couples Therapy Specialty",
  "Se Habla Español",
  "Lyra Health",
  "Spring Health",
  "Evidence-Based, Focused Therapy",
  "Warm · Direct · Nonjudgmental",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="px-8 text-[13px] uppercase tracking-[0.3em] text-cream-50/45 whitespace-nowrap font-sans">
          {item}
        </span>
        <span className="text-gold-500/60 text-[10px]">◆</span>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div className="bg-forest-900 py-4 overflow-hidden border-y border-gold-500/15" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
